import React, { MouseEventHandler } from 'react';
import { useTranslation } from '@app/core/i18n';

import AngleRight from '@ast/magma/components/icon/icons/AngleRight';
import Suitcase from '@ast/magma/components/icon/icons/Suitcase';

import { Button } from '@ast/magma/components/button';

import style from '@app/common/components/UserSelector/UserSelectorButton/UserSelectorButton.pcss';
import { UserOption } from '@app/common/types/UserOption';

export interface UserSelectorButtonProps<User extends UserOption> {
  // eslint-disable-next-line i18next/no-literal-string
  readonly 'data-stable-name': string;
  readonly userOptions?: User[];
  readonly currentUser?: User;
  readonly onClick: MouseEventHandler<HTMLButtonElement>
}

export const UserSelectorButton = React.forwardRef(<User extends UserOption>({
  // eslint-disable-next-line i18next/no-literal-string
  'data-stable-name': dataStableName,
  userOptions,
  currentUser,
  onClick,
}: UserSelectorButtonProps<User>, ref: React.Ref<HTMLButtonElement>) => {
  const { t } = useTranslation();

  return (
    <div className={style.selectorWrapper}>
      <Button
        look="primary"
        data-stable-name={dataStableName}
        onClick={onClick}
        className={style.selectorButton}
        aria-label={t(
          'user-selector.accessible-label|Accessible label template for User Selector button',
          'Selected {{userDisplayName}} • {{userLogin}}. User selector',
          { userDisplayName: currentUser?.userDisplayName || '', userLogin: currentUser?.userLogin || '' },
        )}
        ref={ref}
      >
        <span className={style.selectorTextWrapper}>
          <Suitcase className={style.selectorIcon} />
          <span className={style.userOptionText}>
            { currentUser && userOptions && t(
              'user-selector.text|Text template for User Selector button',
              '<b>{{userDisplayName}}</b> • {{userLogin}}',
              { userDisplayName: currentUser?.userDisplayName || '', userLogin: currentUser?.userLogin || '' },

            )}
          </span>
          <AngleRight className={style.selectorIcon} />
        </span>

      </Button>
    </div>
  );
});
